var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","button-size":"md","hide-footer":"","title":"Histórico Produto"},on:{"hidden":_vm.fecharModal},model:{value:(_vm.modalAberto),callback:function ($$v) {_vm.modalAberto=$$v},expression:"modalAberto"}},[_c('HistoricoSenadoList',{attrs:{"modal":true,"id":_vm.id},on:{"fecharModal":_vm.fecharModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }